import React, { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import Offers from 'src/components/Offers';
import AgreementMissing from 'src/components/EmptyListing/AgreementMissing';
import NoLastSeen from 'src/components/EmptyListing/NoLastSeen';
import SeeAllTile from 'src/components/SeeAllTile';

import { ignoreOffer } from 'src/redux/actions/ignore-offer';
import { toggleLastSeenOffer as toggleOffer } from 'src/redux/actions/toggle-offer';


// eslint-disable-next-line max-statements
const LastSeenOffersContainer = function () {
  const accountURL = useSelector(({ configReducer }) => configReducer.accountURL);
  const { offers, hasProfilingAgreement } = useSelector(({ offersReducer }) => ({
    offers: offersReducer.lastSeenOffers,
    hasProfilingAgreement: offersReducer.hasProfilingAgreement
  }), shallowEqual);
  const dispatch = useDispatch();

  const toggleFavouriteOffer = useCallback((offerId, isFavourite) => {
    dispatch(toggleOffer({ offerId, isFavourite }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ignoreLastSeenOffer = useCallback(offerId => {
    dispatch(ignoreOffer({ offerId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSeeAllTile = () => {
    const seeAllTitleText = 'Zobacz wszystkie rekomendowane oferty';
    const seeAllTitleContentUpperText = 'Zobacz wszystkie';
    const seeAllTitleContentLowerText = 'rekomendowane oferty';

    return (
      <SeeAllTile
        link={ accountURL }
        title={ seeAllTitleText }
      >
        <>
          { seeAllTitleContentUpperText }
          <br />
          { seeAllTitleContentLowerText }
        </>
      </SeeAllTile>
    );
  };

  if (!hasProfilingAgreement) {
    return <AgreementMissing />;
  }

  if (offers.length === 0) {
    return <NoLastSeen />;
  }

  return (
    <>
      <Offers
        offers={ offers }
        remove={ ignoreLastSeenOffer }
        toggleFavourite={ toggleFavouriteOffer }
      />
      { renderSeeAllTile() }
    </>
  );
};

export default LastSeenOffersContainer;
